var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Menu',{attrs:{"menu":_vm.menu}}),_c('div',{staticClass:"main-container",attrs:{"id":"page-wrap"}},[_c('Header',{attrs:{"color":"red"}}),_c('center-container',[_vm._t("default")],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }